import { CcpaStatus } from "@inferno/renderer-shared-core";
import type { Store } from "@inferno/renderer-shared-core";

export function setBeacon(store: Store) {
  if (store.getCcpaStatus() === CcpaStatus.OptOut) {
    window.deferAnalyticsVendorBeacons = true;
  }
}
